import { useState, useEffect } from "react";

const USERS_KEY = "coinbroker_users";
const SESSION_KEY = "coinbroker_session";
const KYC_KEY = "coinbroker_kyc";

function getUsers() { try { return JSON.parse(localStorage.getItem(USERS_KEY) || "[]"); } catch { return []; } }
function saveUsers(u) { localStorage.setItem(USERS_KEY, JSON.stringify(u)); }
function getKyc(email) { try { const all = JSON.parse(localStorage.getItem(KYC_KEY) || "{}"); return all[email] || null; } catch { return null; } }
function saveKyc(email, data) { try { const all = JSON.parse(localStorage.getItem(KYC_KEY) || "{}"); all[email] = data; localStorage.setItem(KYC_KEY, JSON.stringify(all)); } catch {} }

const QUIZ = [
  { q: "Что такое токен (цифровой знак)?", opts: ["Законное платёжное средство, обеспеченное государством", "Запись в блокчейне, удостоверяющая наличие прав у владельца", "Банковский депозит в электронной форме", "Электронные деньги, выпущенные банком"], correct: 1 },
  { q: "Какие риски несёт клиент при совершении сделок с токенами?", opts: ["Рисков нет, все операции застрахованы государством", "Только риск технических сбоев", "Рыночный, ликвидности, технологический, регуляторный, контрагентский и операционный риски", "Только риск изменения курса валют"], correct: 2 },
  { q: "Являются ли токены законным платёжным средством?", opts: ["Да, токены приравнены к национальной валюте", "Да, но только на территории ПВТ", "Нет, токены не являются платёжным средством и не обеспечиваются государством", "Да, в рамках Декрета №8"], correct: 2 },
];

const LogoSvg = ({ size = 38 }) => (
  <svg width={size} height={size} viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="60" cy="60" r="54" stroke="#2D2D2D" strokeWidth="6" fill="white"/>
    <circle cx="60" cy="60" r="42" stroke="#2D2D2D" strokeWidth="3" fill="white"/>
    <path d="M30 75 L42 60 L52 68 L65 45 L78 55 L90 30" stroke="#2D2D2D" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    <path d="M84 30 L90 30 L90 36" stroke="#2D2D2D" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    <line x1="35" y1="85" x2="35" y2="70" stroke="#2D2D2D" strokeWidth="4" strokeLinecap="round"/>
    <line x1="47" y1="85" x2="47" y2="62" stroke="#2D2D2D" strokeWidth="4" strokeLinecap="round"/>
    <line x1="59" y1="85" x2="59" y2="55" stroke="#2D2D2D" strokeWidth="4" strokeLinecap="round"/>
    <line x1="71" y1="85" x2="71" y2="65" stroke="#2D2D2D" strokeWidth="4" strokeLinecap="round"/>
    <line x1="83" y1="85" x2="83" y2="50" stroke="#2D2D2D" strokeWidth="4" strokeLinecap="round"/>
  </svg>
);

export default function App() {
  const [page, setPage] = useState("home");
  const [user, setUser] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => { try { const s = JSON.parse(sessionStorage.getItem(SESSION_KEY)); if (s?.email) setUser(s); } catch {} }, []);

  const login = (u) => { setUser(u); sessionStorage.setItem(SESSION_KEY, JSON.stringify(u)); setPage("dashboard"); };
  const updateUser = (u) => { setUser(u); sessionStorage.setItem(SESSION_KEY, JSON.stringify(u)); const users = getUsers(); const idx = users.findIndex(x => x.email === u.email); if (idx >= 0) { users[idx] = u; saveUsers(users); } };
  const logout = () => { setUser(null); sessionStorage.removeItem(SESSION_KEY); setPage("home"); };

  const showDashboard = page === "dashboard" && user;

  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", background: "var(--bg)", color: "var(--text)", fontFamily: "'DM Sans', sans-serif" }}>
      <style>{STYLES}</style>
      <header className="header">
        <div className="header-inner">
          <div className="logo" onClick={() => setPage(user ? "dashboard" : "home")}>
            <LogoSvg size={38} />
            <div className="logo-text">Coin <span>Broker</span></div>
          </div>
          <button className="mobile-toggle" onClick={() => setMenuOpen(!menuOpen)}><span /><span /><span /></button>
          <div className={`nav-buttons${menuOpen ? " open" : ""}`}>
            {user ? (<>
              <button className="btn btn-ghost" onClick={() => { setPage("dashboard"); setMenuOpen(false); }}>Личный кабинет</button>
              <div className="user-badge"><div className="user-avatar">{user.name?.charAt(0)?.toUpperCase() || "U"}</div><span className="user-name">{user.name}</span></div>
              <button className="btn btn-ghost" onClick={logout}>Выйти</button>
            </>) : (<>
              <button className="btn btn-outline" onClick={() => { setPage("login"); setMenuOpen(false); }}>Вход</button>
              <button className="btn btn-primary" onClick={() => { setPage("register"); setMenuOpen(false); }}>Регистрация</button>
            </>)}
          </div>
        </div>
      </header>

      {!showDashboard && (
        <main className="hero">
          <div className="hero-content">
            <LogoSvg size={80} />
            <h1 style={{marginTop: 24}}>Торгуйте <em>криптоактивами</em> просто и легально</h1>
            <div className="hero-buttons">
              {user ? (
                <button className="btn btn-primary btn-lg" onClick={() => setPage("dashboard")}>Личный кабинет</button>
              ) : (<>
                <button className="btn btn-primary btn-lg" onClick={() => setPage("register")}>Начать</button>
                <button className="btn btn-outline btn-lg" onClick={() => setPage("login")}>Войти в аккаунт</button>
              </>)}
            </div>
          </div>
        </main>
      )}

      {showDashboard && <Dashboard user={user} updateUser={updateUser} />}
      {page === "login" && <LoginModal onClose={() => setPage("home")} onLogin={login} onSwitch={() => setPage("register")} />}
      {page === "register" && <RegisterModal onClose={() => setPage("home")} onRegistered={login} onSwitch={() => setPage("login")} />}

      <footer className="footer">
        <div className="footer-inner">
          <div className="footer-grid">
            <div className="footer-col">
              <div className="footer-logo"><LogoSvg size={32} /><div className="footer-logo-text">Coin Broker</div></div>
              <p>Оператором платформы является ООО «Коин Брокер». Торгуйте цифровыми активами в правовом поле Республики Беларусь.</p>
            </div>
            <div className="footer-col">
              <h4>Документы</h4>
              <ul>
                <li><a href="docs/general_terms.pdf" target="_blank" rel="noopener noreferrer">Общие условия оказания услуг</a></li>
                <li><a href="docs/public_offer.pdf" target="_blank" rel="noopener noreferrer">Публичный клиентский договор</a></li>
                <li><a href="docs/risk_disclosure.pdf" target="_blank" rel="noopener noreferrer">Уведомление о рисках</a></li>
                <li><a href="docs/restricted_jurisdictions.pdf" target="_blank" rel="noopener noreferrer">Юрисдикции, по которым ограничено оказание услуг</a></li>
                <li><a href="docs/conflict_of_interest.pdf" target="_blank" rel="noopener noreferrer">Конфликт интересов</a></li>
                <li><a href="docs/privacy_policy.pdf" target="_blank" rel="noopener noreferrer">Политика конфиденциальности</a></li>
                <li><a href="docs/risk_management.pdf" target="_blank" rel="noopener noreferrer">Управление рисками</a></li>
              </ul>
            </div>
            <div className="footer-col">
              <h4>Контакты</h4>
              <ul>
                <li>ООО «Коин Брокер»</li>
                <li>УНП 193878788</li>
                <li>220019, г. Минск, ул. Свердлова, д. 11, пом. 327, каб. 4</li>
                <li style={{ marginTop: 8 }}>Режим работы платформы — 24/7</li>
                <li>Режим работы офиса — ПН-ПТ, 09:00–18:00 (UTC+3)</li>
              </ul>
            </div>
          </div>
          <div className="footer-bottom"><span className="footer-copy">© {new Date().getFullYear()} ООО «Коин Брокер». Все права защищены.</span></div>
          <div className="footer-legal">ООО «Коин Брокер» является резидентом Парка высоких технологий и осуществляет деятельность в соответствии с Декретом Президента Республики Беларусь от 21 декабря 2017 г. № 8 «О развитии цифровой экономики». Криптоактивы не являются платежным средством. Торговля цифровыми активами подвержена рыночным, техническим и юридическим рискам.</div>
        </div>
      </footer>
    </div>
  );
}

/* ═══════════════ DASHBOARD ═══════════════ */
function Dashboard({ user, updateUser }) {
  const status = user.status || "new";
  const getStep = () => {
    if (status === "new" || status === "kyc_pending") return "kyc";
    if (status === "kyc_review") return "review";
    if (status === "test") return "test";
    return "done";
  };
  const step = getStep();
  const STEPS = [
    { key: "kyc", label: "Идентификация", num: 1 },
    { key: "review", label: "Верификация", num: 2 },
    { key: "test", label: "Тест", num: 3 },
  ];
  const stepIdx = STEPS.findIndex(s => s.key === step);
  const activeIdx = step === "done" ? STEPS.length : stepIdx;

  return (
    <div className="dash">
      <div className="dash-inner">
        <div className="dash-header">
          <h2>Личный кабинет</h2>
          <div className="dash-status">Статус: <span className={`status-tag status-${step}`}>
            {step === "kyc" && "Не верифицирован"}{step === "review" && "На проверке"}{step === "test" && "Пройдите тест"}{step === "done" && "Активный клиент"}
          </span></div>
        </div>
        <div className="stepper">
          {STEPS.map((s, i) => (
            <div key={s.key} className={`stepper-item${i <= activeIdx ? " active" : ""}${i < activeIdx ? " done" : ""}`}>
              <div className="stepper-circle">{i < activeIdx ? "✓" : s.num}</div>
              <span className="stepper-label">{s.label}</span>
              {i < STEPS.length - 1 && <div className={`stepper-line${i < activeIdx ? " done" : ""}`} />}
            </div>
          ))}
        </div>
        {step === "kyc" && <KycForm user={user} updateUser={updateUser} />}
        {step === "review" && <ReviewStep user={user} updateUser={updateUser} />}
        {step === "test" && <TestStep user={user} updateUser={updateUser} />}
        {step === "done" && <DoneStep />}
      </div>
    </div>
  );
}

/* ─── Done Step ─── */
function DoneStep() {
  return (
    <div className="dash-card" style={{ textAlign: "center" }}>
      <div className="review-icon">✅</div>
      <h3>Верификация завершена</h3>
      <p className="dash-card-sub">Вы успешно прошли все этапы идентификации и тест компетентности. Ваш аккаунт полностью активен.</p>
    </div>
  );
}

/* ─── KYC Form ─── */
function KycForm({ user, updateUser }) {
  const existing = getKyc(user.email) || {};
  const [form, setForm] = useState({
    lastName: existing.lastName || "", firstName: existing.firstName || "", middleName: existing.middleName || "",
    birthDate: existing.birthDate || "", citizenship: existing.citizenship || "BY",
    passportSeries: existing.passportSeries || "", passportNumber: existing.passportNumber || "",
    passportIssueDate: existing.passportIssueDate || "", passportIssuedBy: existing.passportIssuedBy || "",
    regAddress: existing.regAddress || "", phone: existing.phone || "",
  });
  const [passportFile, setPassportFile] = useState(null);
  const [selfieFile, setSelfieFile] = useState(null);
  const [error, setError] = useState("");
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const submit = (e) => {
    e.preventDefault(); setError("");
    const required = ["lastName","firstName","birthDate","passportSeries","passportNumber","passportIssueDate","passportIssuedBy","regAddress","phone"];
    for (const k of required) { if (!form[k]?.trim()) { setError("Заполните все обязательные поля"); return; } }
    if (!passportFile) { setError("Загрузите скан/фото паспорта"); return; }
    saveKyc(user.email, { ...form, passportFileName: passportFile.name, selfieFileName: selfieFile?.name || null, submittedAt: new Date().toISOString() });
    updateUser({ ...user, status: "kyc_review" });
  };
  return (
    <div className="dash-card">
      <h3>Идентификация (KYC)</h3>
      <p className="dash-card-sub">Заполните данные и загрузите документы для прохождения верификации</p>
      <form onSubmit={submit} className="kyc-form">
        <div className="form-row"><div className="form-group"><label>Фамилия *</label><input value={form.lastName} onChange={e => set("lastName", e.target.value)} placeholder="Иванов" /></div><div className="form-group"><label>Имя *</label><input value={form.firstName} onChange={e => set("firstName", e.target.value)} placeholder="Иван" /></div><div className="form-group"><label>Отчество</label><input value={form.middleName} onChange={e => set("middleName", e.target.value)} placeholder="Иванович" /></div></div>
        <div className="form-row"><div className="form-group"><label>Дата рождения *</label><input type="date" value={form.birthDate} onChange={e => set("birthDate", e.target.value)} /></div><div className="form-group"><label>Гражданство</label><select value={form.citizenship} onChange={e => set("citizenship", e.target.value)} className="form-select"><option value="BY">Беларусь</option><option value="RU">Россия</option><option value="KZ">Казахстан</option><option value="OTHER">Другое</option></select></div><div className="form-group"><label>Телефон *</label><input value={form.phone} onChange={e => set("phone", e.target.value)} placeholder="+375291234567" /></div></div>
        <div className="form-row"><div className="form-group"><label>Серия паспорта *</label><input value={form.passportSeries} onChange={e => set("passportSeries", e.target.value)} placeholder="MP" /></div><div className="form-group"><label>Номер паспорта *</label><input value={form.passportNumber} onChange={e => set("passportNumber", e.target.value)} placeholder="1234567" /></div><div className="form-group"><label>Дата выдачи *</label><input type="date" value={form.passportIssueDate} onChange={e => set("passportIssueDate", e.target.value)} /></div></div>
        <div className="form-group"><label>Кем выдан *</label><input value={form.passportIssuedBy} onChange={e => set("passportIssuedBy", e.target.value)} placeholder="Минский РУВД" /></div>
        <div className="form-group"><label>Адрес регистрации *</label><input value={form.regAddress} onChange={e => set("regAddress", e.target.value)} placeholder="г. Минск, ул. Примерная, д. 1, кв. 1" /></div>
        <div className="form-row" style={{ gridTemplateColumns: "1fr 1fr" }}>
          <div className="form-group"><label>Скан/фото паспорта (главная + прописка) *</label><div className="file-upload"><input type="file" accept="image/*,.pdf" onChange={e => setPassportFile(e.target.files[0])} /><div className="file-upload-label">{passportFile ? passportFile.name : "Выберите файл"}</div></div></div>
          <div className="form-group"><label>Селфи с паспортом (опционально)</label><div className="file-upload"><input type="file" accept="image/*" onChange={e => setSelfieFile(e.target.files[0])} /><div className="file-upload-label">{selfieFile ? selfieFile.name : "Выберите файл"}</div></div></div>
        </div>
        {error && <div className="form-error">{error}</div>}
        <button type="submit" className="btn btn-primary btn-lg" style={{ marginTop: 8 }}>Отправить на проверку</button>
      </form>
    </div>
  );
}

/* ─── Review Step ─── */
function ReviewStep({ user, updateUser }) {
  const kyc = getKyc(user.email);
  return (
    <div className="dash-card" style={{ textAlign: "center" }}>
      <div className="review-icon">⏳</div>
      <h3>Документы на проверке</h3>
      <p className="dash-card-sub">Ваши данные отправлены на верификацию. Обычно проверка занимает от 10 минут до 3 рабочих дней.</p>
      {kyc && <p style={{ fontSize: 13, color: "var(--text-secondary)", marginTop: 12 }}>Отправлено: {new Date(kyc.submittedAt).toLocaleString("ru-RU")}</p>}
      <div style={{ marginTop: 24, padding: 16, background: "var(--accent-light)", borderRadius: "var(--radius-sm)", fontSize: 13, color: "var(--accent)" }}>Для демо-режима: нажмите кнопку ниже, чтобы подтвердить верификацию</div>
      <button className="btn btn-primary btn-lg" style={{ marginTop: 16 }} onClick={() => updateUser({ ...user, status: "test" })}>Подтвердить верификацию (демо)</button>
    </div>
  );
}

/* ─── Test Step (with green/red feedback) ─── */
function TestStep({ user, updateUser }) {
  const [current, setCurrent] = useState(0);
  const [selected, setSelected] = useState(null);
  const [feedback, setFeedback] = useState(null); // null | "correct" | "wrong"
  const [score, setScore] = useState(0);
  const [done, setDone] = useState(false);

  const q = QUIZ[current];

  const handleSelect = (i) => {
    if (feedback) return; // already answered, wait for next
    setSelected(i);
    if (i === q.correct) {
      setFeedback("correct");
      setScore(s => s + 1);
      // auto-advance after delay
      setTimeout(() => {
        if (current < QUIZ.length - 1) {
          setCurrent(c => c + 1);
          setSelected(null);
          setFeedback(null);
        } else {
          setDone(true);
          updateUser({ ...user, status: "active" });
        }
      }, 1200);
    } else {
      setFeedback("wrong");
      // allow retry: clear after delay
      setTimeout(() => {
        setSelected(null);
        setFeedback(null);
      }, 1200);
    }
  };

  if (done) {
    return (
      <div className="dash-card" style={{ textAlign: "center" }}>
        <div className="review-icon">✅</div>
        <h3>Тест пройден!</h3>
        <p className="dash-card-sub">Вы правильно ответили на все вопросы. Верификация завершена.</p>
      </div>
    );
  }

  return (
    <div className="dash-card">
      <h3>Тест компетентности</h3>
      <p className="dash-card-sub">Вопрос {current + 1} из {QUIZ.length}. Выберите правильный ответ. При неверном ответе попробуйте ещё раз.</p>
      <div className="quiz-progress"><div className="quiz-progress-bar" style={{ width: `${(current / QUIZ.length) * 100}%` }} /></div>
      <div className="quiz-question">{q.q}</div>
      <div className="quiz-options">
        {q.opts.map((opt, i) => {
          let cls = "quiz-option";
          if (feedback && i === q.correct) cls += " correct";
          else if (feedback === "wrong" && i === selected) cls += " wrong";
          else if (!feedback && i === selected) cls += " selected";
          return (
            <div key={i} className={cls} onClick={() => handleSelect(i)}>
              <div className="quiz-radio">
                {((feedback && i === q.correct) || (!feedback && i === selected)) && <div className="quiz-radio-dot" />}
              </div>
              <span>{opt}</span>
            </div>
          );
        })}
      </div>
      {feedback === "wrong" && <div className="form-error" style={{ marginTop: 12 }}>Неверный ответ. Попробуйте ещё раз.</div>}
    </div>
  );
}

/* ═══════════════ LOGIN MODAL ═══════════════ */
function LoginModal({ onClose, onLogin, onSwitch }) {
  const [email, setEmail] = useState(""); const [password, setPassword] = useState(""); const [error, setError] = useState("");
  const handleSubmit = (e) => {
    e.preventDefault(); setError("");
    if (!email || !password) { setError("Заполните все поля"); return; }
    const users = getUsers(); const found = users.find(u => u.email.toLowerCase() === email.toLowerCase());
    if (!found) { setError("Пользователь не найден"); return; }
    if (found.password !== password) { setError("Неверный пароль"); return; }
    onLogin(found);
  };
  return (
    <div className="auth-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="auth-card">
        <button className="auth-close" onClick={onClose}>×</button>
        <h2>Вход</h2><p className="auth-sub">Войдите в свой аккаунт Coin Broker</p>
        <form onSubmit={handleSubmit}>
          <div className="form-group"><label>Электронная почта</label><input type="email" placeholder="name@example.com" value={email} onChange={e => setEmail(e.target.value)} /></div>
          <div className="form-group"><label>Пароль</label><input type="password" placeholder="Введите пароль" value={password} onChange={e => setPassword(e.target.value)} /></div>
          {error && <div className="form-error">{error}</div>}
          <button type="submit" className="btn btn-primary btn-lg form-submit">Войти</button>
        </form>
        <div className="auth-switch">Нет аккаунта?{" "}<a onClick={onSwitch} href="#!">Зарегистрироваться</a></div>
      </div>
    </div>
  );
}

/* ═══════════════ REGISTER MODAL ═══════════════ */
function RegisterModal({ onClose, onRegistered, onSwitch }) {
  const [name, setName] = useState(""); const [email, setEmail] = useState("");
  const [password, setPassword] = useState(""); const [password2, setPassword2] = useState("");
  const [acceptOffer, setAcceptOffer] = useState(false); const [acceptPD, setAcceptPD] = useState(false);
  const [error, setError] = useState("");
  const handleSubmit = (e) => {
    e.preventDefault(); setError("");
    if (!name.trim() || !email || !password) { setError("Заполните все поля"); return; }
    if (name.trim().split(/\s+/).length < 2) { setError("Введите полное ФИО (минимум имя и фамилия)"); return; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { setError("Некорректный формат почты"); return; }
    if (password.length < 6) { setError("Пароль — минимум 6 символов"); return; }
    if (password !== password2) { setError("Пароли не совпадают"); return; }
    if (!acceptOffer) { setError("Необходимо принять условия Публичной оферты"); return; }
    if (!acceptPD) { setError("Необходимо дать согласие на обработку персональных данных"); return; }
    const users = getUsers();
    if (users.find(u => u.email.toLowerCase() === email.toLowerCase())) { setError("Эта почта уже зарегистрирована"); return; }
    const newUser = { name: name.trim(), email: email.toLowerCase(), password, status: "new" };
    users.push(newUser); saveUsers(users); onRegistered(newUser);
  };
  return (
    <div className="auth-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="auth-card">
        <button className="auth-close" onClick={onClose}>×</button>
        <h2>Регистрация</h2><p className="auth-sub">Создайте аккаунт Coin Broker</p>
        <form onSubmit={handleSubmit}>
          <div className="form-group"><label>ФИО</label><input type="text" placeholder="Иванов Иван Иванович" value={name} onChange={e => setName(e.target.value)} /></div>
          <div className="form-group"><label>Электронная почта</label><input type="email" placeholder="name@example.com" value={email} onChange={e => setEmail(e.target.value)} /></div>
          <div className="form-group"><label>Пароль</label><input type="password" placeholder="Минимум 6 символов" value={password} onChange={e => setPassword(e.target.value)} /></div>
          <div className="form-group"><label>Подтвердите пароль</label><input type="password" placeholder="Повторите пароль" value={password2} onChange={e => setPassword2(e.target.value)} /></div>
          <div className="form-checkbox"><label><input type="checkbox" checked={acceptOffer} onChange={e => setAcceptOffer(e.target.checked)} /><span>Я принимаю условия <a href="docs/public_offer.pdf" target="_blank" rel="noopener noreferrer">Публичной оферты на заключение договора об оказании услуг по совершению сделок (операций) с цифровыми знаками (токенами) в интересах Клиента</a> (включая документы, являющиеся её неотъемлемой частью)</span></label></div>
          <div className="form-checkbox"><label><input type="checkbox" checked={acceptPD} onChange={e => setAcceptPD(e.target.checked)} /><span>Я даю согласие на <a href="docs/privacy_policy.pdf" target="_blank" rel="noopener noreferrer">обработку персональных данных</a></span></label></div>
          {error && <div className="form-error">{error}</div>}
          <button type="submit" className="btn btn-primary btn-lg form-submit">Создать аккаунт</button>
        </form>
        <div className="auth-switch">Уже есть аккаунт?{" "}<a onClick={onSwitch} href="#!">Войти</a></div>
      </div>
    </div>
  );
}

/* ═══════════════ STYLES ═══════════════ */
const STYLES = `
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700&family=Playfair+Display:wght@400;500;600;700&display=swap');
:root{--bg:#FAFAF7;--surface:#FFFFFF;--text:#1A1A1A;--text-secondary:#6B6B6B;--accent:#0A6847;--accent-light:#0A684712;--accent-hover:#085538;--border:#E8E6E1;--border-light:#F0EEE9;--gold:#C5A55A;--gold-light:#C5A55A15;--error:#C04040;--success:#0A6847;--radius:12px;--radius-sm:8px;--shadow:0 1px 3px rgba(0,0,0,0.04),0 4px 12px rgba(0,0,0,0.03);--shadow-lg:0 4px 24px rgba(0,0,0,0.06)}
*{margin:0;padding:0;box-sizing:border-box}
::selection{background:var(--accent);color:#fff}
.header{position:sticky;top:0;z-index:100;background:rgba(250,250,247,0.85);backdrop-filter:blur(20px);-webkit-backdrop-filter:blur(20px);border-bottom:1px solid var(--border)}
.header-inner{max-width:1200px;margin:0 auto;padding:0 24px;height:72px;display:flex;align-items:center;justify-content:space-between}
.logo{display:flex;align-items:center;gap:10px;cursor:pointer;text-decoration:none}
.logo-text{font-family:'Playfair Display',serif;font-size:22px;font-weight:600;color:var(--text);letter-spacing:-0.3px}
.logo-text span{color:var(--accent)}
.nav-buttons{display:flex;align-items:center;gap:12px}
.btn{display:inline-flex;align-items:center;justify-content:center;padding:10px 22px;border-radius:var(--radius-sm);font-family:'DM Sans',sans-serif;font-size:14px;font-weight:500;cursor:pointer;transition:all .2s ease;border:none;text-decoration:none;white-space:nowrap}
.btn-outline{background:transparent;border:1.5px solid var(--border);color:var(--text)}
.btn-outline:hover{border-color:var(--accent);color:var(--accent);background:var(--accent-light)}
.btn-primary{background:var(--accent);color:#fff;border:1.5px solid var(--accent)}
.btn-primary:hover{background:var(--accent-hover);border-color:var(--accent-hover);transform:translateY(-1px);box-shadow:0 4px 12px rgba(10,104,71,0.25)}
.btn-primary:disabled{opacity:.5;cursor:not-allowed;transform:none;box-shadow:none}
.btn-ghost{background:transparent;color:var(--text-secondary);border:none;padding:8px 14px}
.btn-ghost:hover{color:var(--text);background:var(--border-light)}
.btn-lg{padding:14px 32px;font-size:16px;border-radius:var(--radius)}
.user-badge{display:flex;align-items:center;gap:10px;padding:6px 14px 6px 6px;background:var(--surface);border:1px solid var(--border);border-radius:50px}
.user-avatar{width:32px;height:32px;border-radius:50%;background:var(--accent);color:#fff;display:flex;align-items:center;justify-content:center;font-size:13px;font-weight:600}
.user-name{font-size:14px;font-weight:500;color:var(--text);max-width:120px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.hero{flex:1;display:flex;align-items:center;justify-content:center;text-align:center;padding:80px 24px 100px;position:relative;overflow:hidden}
.hero::before{content:'';position:absolute;top:-200px;right:-200px;width:600px;height:600px;background:radial-gradient(circle,var(--accent-light) 0%,transparent 70%);pointer-events:none}
.hero::after{content:'';position:absolute;bottom:-150px;left:-150px;width:500px;height:500px;background:radial-gradient(circle,var(--gold-light) 0%,transparent 70%);pointer-events:none}
.hero-content{position:relative;z-index:1;max-width:680px;display:flex;flex-direction:column;align-items:center}
.hero h1{font-family:'Playfair Display',serif;font-size:clamp(36px,5vw,56px);font-weight:600;line-height:1.15;letter-spacing:-1px;color:var(--text);margin-bottom:20px}
.hero h1 em{font-style:italic;color:var(--accent)}
.hero-buttons{display:flex;align-items:center;justify-content:center;gap:14px;flex-wrap:wrap}
.auth-overlay{position:fixed;inset:0;z-index:200;background:rgba(0,0,0,0.3);backdrop-filter:blur(4px);display:flex;align-items:center;justify-content:center;padding:24px;animation:fadeIn .2s ease}
@keyframes fadeIn{from{opacity:0}to{opacity:1}}
.auth-card{background:var(--surface);border-radius:16px;padding:40px;width:100%;max-width:420px;box-shadow:var(--shadow-lg);position:relative;animation:slideUp .3s ease;max-height:90vh;overflow-y:auto}
@keyframes slideUp{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}
.auth-close{position:absolute;top:16px;right:16px;width:32px;height:32px;border-radius:50%;border:none;background:var(--border-light);color:var(--text-secondary);font-size:18px;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:all .15s}
.auth-close:hover{background:var(--border);color:var(--text)}
.auth-card h2{font-family:'Playfair Display',serif;font-size:26px;font-weight:600;margin-bottom:8px}
.auth-card .auth-sub{font-size:14px;color:var(--text-secondary);margin-bottom:28px}
.form-group{margin-bottom:18px}
.form-group label{display:block;font-size:13px;font-weight:500;color:var(--text);margin-bottom:6px}
.form-group input,.form-select{width:100%;padding:12px 14px;border:1.5px solid var(--border);border-radius:var(--radius-sm);font-family:'DM Sans',sans-serif;font-size:14px;color:var(--text);background:var(--bg);transition:border-color .2s;outline:none}
.form-group input:focus,.form-select:focus{border-color:var(--accent);background:#fff}
.form-group input::placeholder{color:#B0AEA6}
.form-select{appearance:none;cursor:pointer}
.form-error{font-size:13px;color:var(--error);margin-top:6px}
.form-checkbox{margin-bottom:14px}
.form-checkbox label{display:flex;align-items:flex-start;gap:10px;font-size:13px;line-height:1.5;color:var(--text-secondary);cursor:pointer}
.form-checkbox input[type="checkbox"]{width:18px;height:18px;min-width:18px;margin-top:2px;accent-color:var(--accent);cursor:pointer}
.form-checkbox a{color:var(--accent);text-decoration:none}
.form-checkbox a:hover{text-decoration:underline}
.form-submit{width:100%;margin-top:8px}
.auth-switch{text-align:center;margin-top:20px;font-size:14px;color:var(--text-secondary)}
.auth-switch a{color:var(--accent);cursor:pointer;text-decoration:none;font-weight:500}
.auth-switch a:hover{text-decoration:underline}
.dash{flex:1;padding:32px 24px 60px;background:var(--bg)}
.dash-inner{max-width:960px;margin:0 auto}
.dash-header{display:flex;align-items:center;justify-content:space-between;margin-bottom:28px;flex-wrap:wrap;gap:12px}
.dash-header h2{font-family:'Playfair Display',serif;font-size:28px;font-weight:600}
.dash-status{font-size:14px;color:var(--text-secondary)}
.status-tag{display:inline-block;padding:4px 12px;border-radius:50px;font-size:13px;font-weight:500}
.status-kyc{background:#FFF3CD;color:#856404}
.status-review{background:#CCE5FF;color:#004085}
.status-test{background:#F8D7DA;color:#721C24}
.status-done{background:#D4EDDA;color:#155724}
.stepper{display:flex;align-items:center;justify-content:center;margin-bottom:32px;flex-wrap:wrap;gap:0}
.stepper-item{display:flex;align-items:center;gap:8px}
.stepper-circle{width:36px;height:36px;border-radius:50%;border:2px solid var(--border);display:flex;align-items:center;justify-content:center;font-size:14px;font-weight:600;color:var(--text-secondary);background:var(--surface);transition:all .2s;flex-shrink:0}
.stepper-item.active .stepper-circle{border-color:var(--accent);color:var(--accent);background:var(--accent-light)}
.stepper-item.done .stepper-circle{border-color:var(--accent);background:var(--accent);color:#fff}
.stepper-label{font-size:13px;font-weight:500;color:var(--text-secondary);white-space:nowrap}
.stepper-item.active .stepper-label,.stepper-item.done .stepper-label{color:var(--accent)}
.stepper-line{width:40px;height:2px;background:var(--border);margin:0 8px;flex-shrink:0}
.stepper-line.done{background:var(--accent)}
.dash-card{background:var(--surface);border-radius:var(--radius);border:1px solid var(--border);padding:32px;box-shadow:var(--shadow)}
.dash-card h3{font-family:'Playfair Display',serif;font-size:22px;font-weight:600;margin-bottom:8px}
.dash-card-sub{font-size:14px;color:var(--text-secondary);margin-bottom:24px;line-height:1.6}
.review-icon{font-size:48px;margin-bottom:16px}
.kyc-form .form-row{display:grid;grid-template-columns:1fr 1fr 1fr;gap:16px}
.file-upload{position:relative;border:2px dashed var(--border);border-radius:var(--radius-sm);padding:16px;text-align:center;cursor:pointer;transition:border-color .2s}
.file-upload:hover{border-color:var(--accent)}
.file-upload input{position:absolute;inset:0;opacity:0;cursor:pointer}
.file-upload-label{font-size:13px;color:var(--text-secondary)}
.quiz-progress{width:100%;height:4px;background:var(--border-light);border-radius:2px;margin-bottom:24px;overflow:hidden}
.quiz-progress-bar{height:100%;background:var(--accent);border-radius:2px;transition:width .3s}
.quiz-question{font-size:17px;font-weight:500;line-height:1.6;margin-bottom:20px}
.quiz-options{display:flex;flex-direction:column;gap:10px}
.quiz-option{display:flex;align-items:flex-start;gap:12px;padding:14px 16px;border:1.5px solid var(--border);border-radius:var(--radius-sm);cursor:pointer;transition:all .2s;font-size:14px;line-height:1.5}
.quiz-option:hover{border-color:var(--accent);background:var(--accent-light)}
.quiz-option.selected{border-color:var(--accent);background:var(--accent-light)}
.quiz-option.correct{border-color:#28a745;background:#d4edda;cursor:default}
.quiz-option.correct .quiz-radio{border-color:#28a745}
.quiz-option.correct .quiz-radio-dot{background:#28a745}
.quiz-option.wrong{border-color:#dc3545;background:#f8d7da;cursor:default}
.quiz-option.wrong .quiz-radio{border-color:#dc3545}
.quiz-option.wrong .quiz-radio-dot{background:#dc3545}
.quiz-radio{width:20px;height:20px;min-width:20px;border-radius:50%;border:2px solid var(--border);display:flex;align-items:center;justify-content:center;margin-top:1px;transition:border-color .2s}
.quiz-option.selected .quiz-radio{border-color:var(--accent)}
.quiz-radio-dot{width:10px;height:10px;border-radius:50%;background:var(--accent);transition:background .2s}
.footer{background:#1A1A1A;color:#E0DED8;padding:56px 24px 32px}
.footer-inner{max-width:1200px;margin:0 auto}
.footer-grid{display:grid;grid-template-columns:1.5fr 1fr 1.5fr;gap:48px;padding-bottom:40px;border-bottom:1px solid #2E2E2E}
.footer-col h4{font-family:'Playfair Display',serif;font-size:15px;font-weight:600;color:#FFF;margin-bottom:16px;letter-spacing:.3px}
.footer-col p,.footer-col li{font-size:13px;line-height:1.8;color:#9E9C96}
.footer-col ul{list-style:none}
.footer-col a{color:#9E9C96;text-decoration:none;transition:color .15s}
.footer-col a:hover{color:var(--gold)}
.footer-bottom{padding-top:24px;display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:12px}
.footer-copy{font-size:12px;color:#6B6B6B}
.footer-legal{font-size:11px;color:#555;max-width:1200px;margin:24px auto 0;line-height:1.7;padding-top:20px;border-top:1px solid #2E2E2E}
.footer-logo{display:flex;align-items:center;gap:8px;margin-bottom:16px}
.footer-logo-text{font-family:'Playfair Display',serif;font-size:18px;font-weight:600;color:#FFF}
.mobile-toggle{display:none;width:40px;height:40px;border:none;background:none;cursor:pointer;flex-direction:column;align-items:center;justify-content:center;gap:5px}
.mobile-toggle span{width:22px;height:2px;background:var(--text);border-radius:2px;transition:all .2s}
@media(max-width:768px){
  .nav-buttons{display:none}
  .mobile-toggle{display:flex}
  .nav-buttons.open{display:flex;flex-direction:column;position:absolute;top:72px;right:0;left:0;background:var(--surface);padding:16px 24px;border-bottom:1px solid var(--border);box-shadow:var(--shadow-lg)}
  .nav-buttons.open .btn{width:100%}
  .footer-grid{grid-template-columns:1fr;gap:32px}
  .kyc-form .form-row{grid-template-columns:1fr}
  .stepper{gap:4px}
  .stepper-line{width:20px}
  .stepper-label{display:none}
}
`;
